/**
 * URL for the zra-sync-service dashboard (Next.js app, base path /sync-dashboard).
 *
 * Dev: separate Vite (5173) + sync service (4200) — use full origin.
 * Prod/staging: usually reverse-proxied on the same host as the frontend.
 */
export function getSyncDashboardUrl() {
  if (typeof window !== 'undefined' && window.APP_CONFIG?.SYNC_DASHBOARD_URL) {
    return String(window.APP_CONFIG.SYNC_DASHBOARD_URL).replace(/\/$/, '');
  }
  const fromEnv = import.meta.env.VITE_SYNC_DASHBOARD_URL;
  if (fromEnv) {
    return String(fromEnv).replace(/\/$/, '');
  }
  if (import.meta.env.DEV) {
    return 'http://localhost:4200/sync-dashboard';
  }
  return '/sync-dashboard';
}
